import Vue from 'vue'
import VueRouter from 'vue-router'
import utils from '../assets/js/utils.js';
// import services from '../assets/js/services.js';
// import VueCookies from 'vue-cookies';
import store from '../store';
import { studentRoutes, studentMap } from './studentRoutes.js'; // 学生端路由
import { schoolRoutes, schoolMap } from './schoolRoutes.js'; // 老师端路由
import Page404 from '../pages/Page404.vue' // 404页面
import NoAuth from '../pages/NoAuth.vue' // 404页面
import WorksShow from '../pages/WorksShow.vue'
import CaseDetail from "../pages/CaseDetail.vue" // 案例推优详情页

Vue.use(VueRouter)

var defaltRoute = [
  {
    path: '/:schoolcode(\\d+)?/noauth',
    name: '提示',
    component: NoAuth
  },
  {
    path: '/:schoolcode(\\d+)?/worksshow',
    name: '微电影及大学生讲思政课',
    component: WorksShow
  },
  {
    path: "/:schoolcode(\\d+)?/worksshow/detail",
    name: "案例推优详情页",
    component: CaseDetail
  },
  {
    path: '/:schoolcode(\\d+)?/404',
    name: '404',
    component: Page404
  },

]

const newRoutes = [...defaltRoute, ...studentRoutes, ...schoolRoutes];
const createRouter = () => new VueRouter({
  mode: 'history',
  routes: newRoutes,
})

const router = createRouter()
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

function isRouteMatch (path, arr) {
  return arr.some(item => {
    // 创建一个正则表达式，匹配 item 或 item + '/'
    const regex = new RegExp(`^/${localStorage.getItem("schoolCode")}${item}\/?$`); // eslint-disable-line
    return regex.test(path);
  });
}
function isInitialRouter (path) {
  const regex = new RegExp(`^/${localStorage.getItem("schoolCode")}\/?$`);  // eslint-disable-line
  return regex.test(path);
}


router.beforeEach((to, from, next) => {
  // 路由跳转时页面回到顶部
  document.body.scrollTop = 0 // chrome
  document.documentElement.scrollTop = 0 // firefox
  window.pageYOffset = 0 // safari

  utils.setTitle(to.name);
  let code = to.params && to.params.schoolcode ? to.params.schoolcode : ''
  if (code) {
    localStorage.setItem("schoolCode", code);
  }
  // let appsToken = VueCookies.get("api_token");
  let schoolCode = localStorage.getItem("schoolCode")

  // if (appsToken) {
  if (to.path == `/${schoolCode}/404` || to.path == `/${schoolCode}/noauth` || to.path == `/${schoolCode}/test`) {
    next()
    return
  }
  store.dispatch("getAppsLoginUserInfo").then(res => {
    if (res.code == '0000') {
      if (res.data) {
        let urlCode = utils.getUrlSchoolCode(window.location.pathname)
        if (res.data.school_code != urlCode) {
          window.open(`/${res.data.school_code}`, "_self")
        }

        if (to.path.indexOf("/worksshow") > -1) {
          next()
          return
        }

        // 老师端只有管理员和老师能访问; 老师端和学生端不能互相访问
        if (res.data.user_type == 2 || (res.data.user_type == 1 && (res.data.role_ids == 1 || res.data.role_ids == 2))) {
          if (isInitialRouter(to.path)) {
            next(`/${schoolCode}/school`)
            return
          }
          if (isRouteMatch(to.path, schoolMap)) {
            next()
          } else {
            next(`/${schoolCode}/school`)
          }
        } else {
          // console.log(isInitialRouter(to.path));

          if (isInitialRouter(to.path)) {
            next(`/${schoolCode}/student`)
            return
          }
          if (isRouteMatch(to.path, studentMap)) {
            next()
          } else {
            next(`/${schoolCode}/student`)
          }
        }
      }
    }
  })


})


export default router